
import { create } from "zustand";

interface SessionState {
  token: string;
  userRole: string;
  userName: string;
  userIdData: string;
  setSession: (data: {
    token: string;
    userRole: string;
    userName: string;
    userIdData: string;
  }) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  token: "",
  userRole: "",
  userName: "",
  userIdData: "",
  setSession: ({ token, userRole, userName, userIdData }) =>
    set({ token, userRole, userName, userIdData }),
}));
